// extracted by mini-css-extract-plugin
module.exports = {"container":"todo-board_container__r3RNy","title":"todo-board_title__2Fa3Q","addBtn":"todo-board_addBtn__2wzTV","icon":"todo-board_icon__1_FvV"};